module.exports = __webpack_public_path__ + "static/img/Matrix_B.fd6c79a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/Matrix_B.svg
// module id = 1067
// module chunks = 2